import { Injectable } from '@angular/core';
import { AjaxDataServiceService } from '@admin/core/ajax-data-service.service';
import { UrlConfigContainer } from '@admin/core/url-config';
import { PagingFilter } from '@admin/shared/models/paging-filter.model';
import { CustomerListFilterModel } from '@admin/billing/billing-report/shared/models/customer-list-filter-model';
import { Observable } from 'rxjs';
import { PagingWrapper } from '@admin/core/models/paging-wrapper';
import { CustomerListItemModel } from '@admin/billing/billing-report/shared/models/customer-list-item-model';
import { CustomerListTotals } from '@admin/billing/billing-report/shared/models/customer-list-totals';
import { UrlConfigService } from '@hrra/core';

@Injectable({ providedIn: 'root' })
export class BillingReportService {
  constructor(
    private ajax: AjaxDataServiceService,
    private urlService: UrlConfigService<UrlConfigContainer>
  ) {}

  public listCustomers(
    filter: PagingFilter<CustomerListFilterModel>
  ): Observable<PagingWrapper<CustomerListItemModel>> {
    return this.ajax.postDataPaging(
      this.urlService.urlConfig.api.data.billingReport.list,
      filter.toObject(),
      CustomerListItemModel
    );
  }

  public getCustomersTotalAmounts(
    filter: PagingFilter<CustomerListFilterModel>
  ): Observable<CustomerListTotals> {
    return this.ajax.postData(
      this.urlService.urlConfig.api.data.billingReport.totals,
      filter.toObject(),
      CustomerListTotals
    );
  }
}
